import React from 'react';
import CloseRounded from '@mui/icons-material/CloseRounded';
import GlobalStyles from '@mui/material/GlobalStyles';
import { Box, IconButton, Modal as MuiModal, Typography } from '@mui/material';

import { modalRootCenteredSx, safeAreaInset } from '../platform/safeArea';

/** Google Places appends `.pac-container` to `body`. Modal scroll-lock + focus trap break it — fix z-index and opt out when using Places. */
const placesAutocompleteGlobalStyles = (
  <GlobalStyles
    styles={{
      '.pac-container': {
        zIndex: '2147483647 !important',
      },
    }}
  />
);

export default function Modal({ open, onClose, fullScreen, children, title, maxWidth = 440 }) {
  return (
    <>
      {open ? placesAutocompleteGlobalStyles : null}
      <MuiModal
        open={open}
        onClose={onClose}
        sx={fullScreen ? undefined : modalRootCenteredSx}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            boxShadow: 24,
            outline: 0,
            overflow: 'auto',
            boxSizing: 'border-box',
            ...(fullScreen
              ? {
                  position: 'absolute',
                  inset: 0,
                  width: '100%',
                  height: '100%',
                  maxWidth: '100%',
                  maxHeight: '100%',
                  borderRadius: 0,
                  my: 0,
                  mx: 0,
                  p: 2,
                  pt: `calc(12px + ${safeAreaInset.top})`,
                  pb: safeAreaInset.bottom,
                  pl: safeAreaInset.left,
                  pr: safeAreaInset.right,
                }
              : {
                  position: 'relative',
                  width: '100%',
                  maxWidth,
                  maxHeight: '100%',
                  borderRadius: 2,
                  my: 'auto',
                  mx: 'auto',
                  p: 2,
                  pt: 1.5,
                }),
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              gap: 1,
              mb: 1.5,
            }}
          >
            {title ? (
              <Typography variant="h6" component="h2" sx={{ pr: 1, lineHeight: 1.3, flex: 1 }}>
                {title}
              </Typography>
            ) : (
              <Box sx={{ flex: 1 }} />
            )}
            {onClose ? (
              <IconButton
                aria-label="Close"
                onClick={onClose}
                size="small"
                sx={{ mt: -0.5, mr: -0.5, color: 'text.secondary' }}
              >
                <CloseRounded />
              </IconButton>
            ) : null}
          </Box>
          {children}
        </Box>
      </MuiModal>
    </>
  );
}
